/* PlayShop — tracker comportemental global (CDP) v2.
   Signaux : page/produit/recherche/collection, ajout & modif panier, RAGE-CLICS, temps passé, scroll depth.
   Conforme : ne collecte que si consentement (API confidentialité Shopify) ; sinon attend le consentement.
   Identité : window.PS_TRACK_CTX (customer_id/email) + anonymous_id (persistant) + session_id.
   window.psTrack(type, props) exposé pour instrumenter les outils. */
(function () {
  var ENDPOINT = 'https://ipvzpgwgujamtzztxvcu.supabase.co/functions/v1/track';
  var CFG = window.PS_TRACK_CTX || {};
  function id(prefix, store, key) {
    try { var v = store.getItem(key); if (!v) { v = prefix + Date.now().toString(36) + Math.random().toString(36).slice(2, 8); store.setItem(key, v); } return v; } catch (e) { return prefix + '0'; }
  }
  var anon = id('a', localStorage, 'ps_anon');
  // ⚠️ PAS sessionStorage : il est propre a chaque onglet, donc chaque onglet
  // ouvert comptait comme une nouvelle session (un visiteur en a genere 32 en
  // 23 minutes). Definition standard : une session se poursuit tant que deux
  // evenements sont espaces de moins de 30 minutes.
  var SESSION_MS = 30 * 60 * 1000;
  function sessionCourante() {
    try {
      var maintenant = Date.now();
      var brut = localStorage.getItem('ps_sess_v2');
      var o = null;
      try { o = brut ? JSON.parse(brut) : null; } catch (e) { o = null; }
      if (!o || !o.id || !(maintenant - (Number(o.t) || 0) < SESSION_MS)) {
        o = { id: 's' + maintenant.toString(36) + Math.random().toString(36).slice(2, 8), t: maintenant };
      } else { o.t = maintenant; }
      localStorage.setItem('ps_sess_v2', JSON.stringify(o));
      return o.id;
    } catch (e) { return 's0'; }
  }
  var sess = sessionCourante();

  // --- Consentement (RGPD) : ne tracke que si autorisé ; si pas de framework, first-party autorisé ---
  function consentOK() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp) return true;
      if (typeof cp.analyticsProcessingAllowed === 'function') return !!cp.analyticsProcessingAllowed();
      if (typeof cp.userCanBeTracked === 'function') return !!cp.userCanBeTracked();
      return true;
    } catch (e) { return true; }
  }
  var TRACKING = consentOK();
  // N'espionne PAS le back-office : sur /pages/admin c'est l'exploitant (toi/partenaires) qui opère l'outil,
  // pas un client → sinon faux rage-clics (sélection de texte, clics dans les champs) + temps/pages faussés.
  try { if ((location.pathname || '').toLowerCase().indexOf('/pages/admin') === 0) TRACKING = false; } catch (e) { /* */ }
  // NB : on ne DÉSACTIVE PLUS le tracking pour le staff (toi + partenaires). On collecte TOUT — leurs
  //      visites sont simplement EXCLUES au niveau des analytics (par identité : profil + anonymous_id lié),
  //      dans fn_analytics_vision. « Collecter mais ne pas inclure » : la data brute reste, les stats sont propres.

  function send(events) {
    if (!TRACKING || !events || !events.length) return;
    var payload = JSON.stringify({
      shopify_customer_id: CFG.customer_id || null, email: CFG.email || null,
      anonymous_id: anon, session_id: sess, page_url: location.pathname, events: events
    });
    // `track` n'accepte PLUS une identité auto-déclarée : le `shopify_customer_id` du corps est
    // ignoré côté serveur (on pouvait forger des events sur le profil d'autrui et rattacher son
    // anonymous_id à une victime). Seul `x-ps-token` — le secret propre au client — rattache un
    // event à un profil. Sans jeton, l'event est ingéré mais reste ANONYME : c'est voulu, le
    // tracker doit continuer à mesurer les visiteurs non connectés.
    // ⚠️ sendBeacon NE PEUT PAS poser d'en-tête custom. Donc dès qu'on a un jeton on passe par
    // fetch + `keepalive: true` — l'équivalent moderne, qui survit aussi au déchargement de la
    // page. sendBeacon reste le chemin des visiteurs anonymes, qui n'ont rien à signer.
    var tok = '';
    try { tok = window.PS_AUTH_TOKEN || ''; } catch (e) { /* */ }
    if (tok) {
      try { fetch(ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'application/json', 'x-ps-token': tok }, body: payload, keepalive: true }); return; } catch (e) { /* */ }
    }
    try { if (navigator.sendBeacon) { navigator.sendBeacon(ENDPOINT, payload); return; } } catch (e) { /* */ }
    try { fetch(ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: payload, keepalive: true }); } catch (e) { /* */ }
  }
  window.psTrack = function (type, props) { send([{ event_type: type, properties: props || {}, page_url: location.pathname }]); };
  // Flush events poussés AVANT que le tracker soit prêt (les scripts d'outils tournent souvent avant ce defer)
  try { var q = window.__psTrackQ; if (q && q.length) { q.forEach(function (e) { window.psTrack(e[0], e[1]); }); window.__psTrackQ = []; } } catch (e) { /* */ }
  window.__psTrackQ = { push: function (e) { window.psTrack(e[0], e[1]); } }; // après init, push == envoi direct

  // --- Attribution : d'où vient le visiteur (UTM / referrer / canal), first-touch + last-touch ---
  function parseAttribution() {
    var p; try { p = new URLSearchParams(location.search); } catch (e) { p = { get: function () { return null; } }; }
    var utm = {};
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) { var v = p.get(k); if (v) utm[k] = String(v).slice(0, 120); });
    if (!utm.utm_source) { if (p.get('gclid')) { utm.utm_source = 'google'; utm.utm_medium = utm.utm_medium || 'cpc'; } else if (p.get('fbclid')) { utm.utm_source = 'facebook'; utm.utm_medium = utm.utm_medium || 'social'; } }
    var ref = document.referrer || '', refHost = '';
    try { if (ref) refHost = new URL(ref).hostname.replace(/^www\./, ''); } catch (e) { }
    var selfHost = location.hostname.replace(/^www\./, '');
    var external = !!refHost && refHost !== selfHost;
    var channel;
    if (Object.keys(utm).length) channel = 'campaign';
    else if (!ref) channel = 'direct';
    else if (external) {
      if (/(^|\.)(google|bing|yahoo|duckduckgo|ecosia|qwant)\./.test(refHost)) channel = 'organic_search';
      else if (/(facebook|instagram|t\.co|twitter|x\.com|tiktok|youtube|reddit|discord|pinterest|linkedin|snapchat)/.test(refHost)) channel = 'social';
      else channel = 'referral';
    } else channel = 'internal';
    var src = utm.utm_source || (external ? refHost : null) || channel;
    return { utm: utm, channel: channel, source: src, medium: utm.utm_medium || (channel === 'organic_search' ? 'organic' : (channel === 'social' ? 'social' : (channel === 'referral' ? 'referral' : channel))), campaign: utm.utm_campaign || null, ref_host: external ? refHost : null, landing: location.pathname };
  }
  function fireAttribution() {
    try {
      var cur = parseAttribution();
      var ft = null, lt = null;
      try { ft = JSON.parse(localStorage.getItem('ps_ft') || 'null'); } catch (e) { }
      if (!ft && cur.channel !== 'internal') { ft = cur; try { localStorage.setItem('ps_ft', JSON.stringify(ft)); } catch (e) { } }
      try { lt = JSON.parse(sessionStorage.getItem('ps_lt') || 'null'); } catch (e) { }
      if (cur.channel !== 'internal' || !lt) { lt = cur; try { sessionStorage.setItem('ps_lt', JSON.stringify(lt)); } catch (e) { } }
      if (sessionStorage.getItem('ps_attr_sent')) return;
      sessionStorage.setItem('ps_attr_sent', '1');
      var eff = lt || cur;
      window.psTrack('attribution', {
        channel: eff.channel, source: eff.source, medium: eff.medium, campaign: eff.campaign, landing: cur.landing,
        first_channel: (ft || eff).channel, first_source: (ft || eff).source, first_campaign: (ft || eff).campaign
      });
    } catch (e) { /* */ }
  }

  // --- Détection AUTO d'ouverture d'outil (aucune édition par outil requise) via template.suffix ---
  var TOOL_MAP = {
    'scan-cartes': 'scan', 'centrage': 'centering', 'calendrier': 'calendar',
    'deck-builder': 'deck', 'deck-view': 'deck', 'deck-hub': 'deck', 'lorcana-deck-builder': 'deck',
    'suivi-collection': 'collection_hub', 'suivi-licence': 'collection',
    'boutique-recompenses': 'rewards', 'paliers': 'loyalty', 'idees': 'feedback',
    'abonnement-vip': 'vip', 'ecosysteme': 'ecosysteme', 'dashboard': 'dashboard'
  };
  var toolName = TOOL_MAP[CFG.template || ''] || null;
  window.PS_TOOL = toolName;
  function fireTool() { if (toolName) window.psTrack('tool_open', { tool: toolName, template: CFG.template, handle: CFG.page_handle || null }); }

  // --- Instrumentation DÉCLARATIVE : tout élément [data-track] loggé au clic (marche pour le DOM dynamique) ---
  document.addEventListener('click', function (e) {
    try {
      var el = e.target && e.target.closest && e.target.closest('[data-track]');
      if (!el) return;
      var evt = el.getAttribute('data-track'); if (!evt) return;
      var props = {}; if (toolName) props.tool = toolName;
      for (var i = 0; i < el.attributes.length; i++) { var a = el.attributes[i]; if (a.name.indexOf('data-track-') === 0) props[a.name.slice(11)] = a.value; }
      window.psTrack(evt, props);
    } catch (err) { /* */ }
  }, true);

  // --- Vue initiale (page / produit / recherche / collection) via ShopifyAnalytics.meta ---
  var fired = false;
  function fireInitial() {
    if (fired) return; fired = true;
    fireAttribution();
    var meta = (window.ShopifyAnalytics && window.ShopifyAnalytics.meta) || {};
    var pt = (meta.page && meta.page.pageType) || '';
    // FALLBACK ROBUSTE : ShopifyAnalytics.meta arrive souvent APRÈS le tracker (course) → sans ça,
    // product_view/collection_view/search ne partaient JAMAIS (seule page_view 'other'). On déduit
    // le type depuis le template serveur (CFG.template, toujours présent) ou l'URL.
    if (!pt) {
      var tpl = String(CFG.template || '').split('.')[0];
      if (tpl === 'product' || /\/products\//.test(location.pathname)) pt = 'product';
      else if (tpl === 'collection' || /\/collections\//.test(location.pathname)) pt = 'collection';
      else if (tpl === 'search' || /\/search(\/|$|\?)/.test(location.pathname)) pt = 'search';
    }
    var batch = [{ event_type: 'page_view', properties: { type: pt || 'other' } }];
    try {
      // product_view part dès que la page EST une page produit — sans exiger meta.product (souvent null si la course a lieu).
      if (pt === 'product') batch.push({ event_type: 'product_view', properties: { id: (meta.product && meta.product.id) || null, handle: (location.pathname.split('/products/')[1] || '').split('?')[0] || (CFG.page_handle || null), title: (meta.product && meta.product.variants && meta.product.variants[0] && meta.product.variants[0].name) || null } });
      else if (pt === 'search') batch.push({ event_type: 'search', properties: { q: new URLSearchParams(location.search).get('q') || '' } });
      else if (pt === 'collection') batch.push({ event_type: 'collection_view', properties: { handle: (location.pathname.split('/collections/')[1] || '').split('?')[0] || (CFG.page_handle || null) } });
    } catch (e) { /* */ }
    send(batch);
  }
  if (TRACKING) { fireInitial(); fireTool(); }
  // si le consentement arrive plus tard -> on démarre
  document.addEventListener('visitorConsentCollected', function () { if (!TRACKING && consentOK()) { TRACKING = true; fireInitial(); fireTool(); } });

  // --- Recherche INSTANTANÉE (barre modale du header + page /search) : capte ce que les gens tapent.
  //     La barre instantanée ne navigue jamais vers /search?q= → sans ça, LA recherche la plus utilisée
  //     n'était jamais mesurée. Débounce 900ms, min 2 caractères, une seule fois par requête distincte. ---
  (function () {
    var lastQ = '', tmr = null;
    document.addEventListener('input', function (e) {
      var el = e.target;
      if (!el || !el.matches || !el.matches('[data-ps-search-input], #ps-search-input')) return;
      var q = String(el.value || '').trim().toLowerCase();
      clearTimeout(tmr);
      if (q.length < 3) return;
      // Débounce 1,4s : on ne capte la recherche qu'une fois la frappe VRAIMENT posée → évite les mots
      // en cours ou abandonnés (ex. « pik » avant/à la place de « pikachu »). Une fois par requête distincte.
      tmr = setTimeout(function () { if (q && q !== lastQ) { lastQ = q; try { window.psTrack('search', { q: q, live: true }); } catch (er) { /* */ } } }, 1400);
    }, true);
  })();

  // --- Panier : ajout + modification (suppression / quantité) ---
  // ⚠️ 'add_to_cart' partait avec un objet VIDE : on savait qu'un ajout avait eu
  // lieu, jamais lequel. Or /cart/add.js RENVOIE la ligne ajoutée (produit,
  // variante, titre, prix, quantité) — il suffisait de lire la réponse.
  // Sans ça, l'intention d'achat la plus forte du site était inexploitable pour
  // le ciblage : seule l'URL de la page permettait de deviner le produit, et un
  // ajout depuis une page de collection ne disait rien du tout.
  function proprietesPanier(rep) {
    try {
      var it = (rep && rep.items && rep.items.length) ? rep.items[0] : rep;
      if (!it || !(it.product_id || it.id)) return null;
      var h = it.handle || null;
      if (!h && it.url) { h = String(it.url).split('/products/')[1] || ''; h = h.split('?')[0] || null; }
      return {
        id: it.product_id || null,
        variant_id: it.variant_id || it.id || null,
        handle: h,
        title: it.product_title || it.title || null,
        price: (typeof it.price === 'number') ? (it.price / 100) : null,
        quantity: it.quantity || 1
      };
    } catch (e) { return null; }
  }
  function hookCart(url, rep) {
    try {
      if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
        try { sessionStorage.setItem('ps_cart', '1'); } catch (e) {}
        window.psTrack('add_to_cart', proprietesPanier(rep) || {});
      }
      else if (/\/cart\/(change|update)(\.js)?(\?|$)/.test(url)) window.psTrack('remove_from_cart', { note: 'cart_change' });
    } catch (e) { /* */ }
  }
  try {
    var of = window.fetch;
    if (of) window.fetch = function (u) {
      var url = '';
      try { url = (typeof u === 'string') ? u : (u && u.url) || ''; } catch (e) {}
      var p = of.apply(this, arguments);
      try {
        if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
          // On lit une COPIE de la réponse : l'originale doit rester intacte
          // pour le thème, sinon le tiroir panier ne se remplit plus.
          p.then(function (r) {
            try {
              r.clone().json().then(function (j) { hookCart(url, j); })
                .catch(function () { hookCart(url); });
            } catch (e) { hookCart(url); }
          }).catch(function () { /* requête échouée : rien à journaliser */ });
        } else {
          hookCart(url);
        }
      } catch (e) { try { hookCart(url); } catch (e2) { /* */ } }
      return p;
    };
    var ox = window.XMLHttpRequest && window.XMLHttpRequest.prototype.open;
    if (ox) window.XMLHttpRequest.prototype.open = function (m, url) {
      try {
        var self = this;
        this.addEventListener('load', function () {
          var j = null;
          try { j = JSON.parse(self.responseText); } catch (e) { /* pas du JSON */ }
          hookCart(url || '', j);
        });
      } catch (e) { /* */ }
      return ox.apply(this, arguments);
    };
  } catch (e) { /* */ }

  // --- Départ vers le checkout ---
  // ⚠️ Le nom DOIT être 'begin_checkout' : la fn `track` a une liste blanche de types
  // (ALLOWED) et jette silencieusement tout le reste en répondant `{ok:true, ingested:0}`.
  // Un nom inventé (ex. 'checkout_started') disparaît sans la moindre erreur.
  // 'begin_checkout' était déjà attendu par le tunnel… mais RIEN ne l'émettait :
  // l'étape « Démarrent le checkout » (onglet Vision) affichait 0 pour toujours.
  // Posé ICI (dans le tracker) et non dans le tiroir panier, pour couvrir TOUS les points
  // d'entrée d'un coup : tiroir, page /cart, et tout futur bouton.
  // Le checkout est sur un domaine Shopify où notre tracker ne tourne pas → c'est le dernier
  // signal exploitable côté boutique. sendBeacon survit à la navigation qui suit le clic.
  try {
    document.addEventListener('click', function (e) {
      try {
        var t = e.target;
        if (!t || !t.closest) return;
        var el = t.closest('a[href*="/checkout"], [data-ps-checkout-btn], button[name="checkout"]');
        if (!el) return;
        // Panier vide : le bouton est neutralisé par ps-cart-drawer → ce n'est pas un vrai départ.
        if (el.dataset && el.dataset.psCheckoutEmpty !== undefined) return;
        window.psTrack('begin_checkout', {});
      } catch (err) { /* ne JAMAIS bloquer le clic vers le paiement */ }
    }, true);
  } catch (e) { /* */ }

  // --- Rage-clics (frustration : 4+ clics rapprochés au même endroit) ---
  var clicks = [];
  document.addEventListener('click', function (e) {
    var now = Date.now();
    clicks.push({ t: now, x: e.clientX, y: e.clientY });
    clicks = clicks.filter(function (c) { return now - c.t < 1000; });
    var near = clicks.filter(function (c) { return Math.abs(c.x - e.clientX) < 40 && Math.abs(c.y - e.clientY) < 40; });
    if (near.length >= 4) { window.psTrack('rage_click', { el: (e.target && e.target.tagName) || '', text: ((e.target && (e.target.innerText || e.target.value)) || '').toString().slice(0, 40) }); clicks = []; }
  }, true);

  // --- Scroll depth ---
  var maxScroll = 0;
  window.addEventListener('scroll', function () { try { var h = document.documentElement; var p = Math.round((h.scrollTop + window.innerHeight) / (h.scrollHeight || 1) * 100); if (p > maxScroll) maxScroll = Math.min(100, p); } catch (e) {} }, { passive: true });

  // --- Sortie de page : temps passé + profondeur de scroll ---
  // ⚠️ On mesurait (fermeture − ouverture), donc un onglet oublié comptait comme
  // du temps de lecture (record constaté : 17 h 36 sur une collection).
  // On ne cumule desormais que le temps où l'onglet est VISIBLE. AUCUN PLAFOND :
  // deux heures passees sur ses classeurs, c'est du vrai engagement, pas du bruit.
  // -- 12/09/2026 : l'envoi etait VERROUILLE au premier passage en arriere-plan
  // (left = true, jamais relache). Une notification, un changement d'onglet, un
  // ecran qui s'eteint, et le chronometre restait fige a cet instant : tout ce qui
  // etait lu ENSUITE n'etait jamais envoye. Mesure sur 30 jours : 71 articles
  // scrolles jusqu'au bout comptaient moins de 20 s, donc aucun defi de lecture
  // valide (signale par Zougii.95 le 11/09).
  // On renvoie desormais le cumul a CHAQUE sortie. 'pv' identifie la visite pour
  // que le serveur METTE A JOUR sa mesure au lieu d'empiler des lignes : les vues
  // qui sommeent les secondes (v_dwell_by_page) ne doivent jamais compter deux fois.
  var pv = Math.random().toString(36).slice(2) + Date.now().toString(36);
  var depuis = (document.visibilityState === 'hidden') ? 0 : Date.now();
  var cumulMs = 0, dernierEnvoi = -1;
  function pauseTemps() { if (depuis) { cumulMs += Date.now() - depuis; depuis = 0; } }
  function repriseTemps() { if (!depuis) depuis = Date.now(); }
  function onLeave() {
    pauseTemps();
    var s = Math.round(cumulMs / 1000);
    if (s <= dernierEnvoi) return; // rien de neuf depuis le dernier envoi
    dernierEnvoi = s;
    send([{ event_type: 'time_on_page', properties: { seconds: s, path: location.pathname, pv: pv } },
          { event_type: 'scroll_depth', properties: { max_pct: maxScroll, pv: pv } }]);
  }
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') { pauseTemps(); onLeave(); } else { repriseTemps(); }
  });
  window.addEventListener('pagehide', onLeave);
})();
